import { get, post, getBolb } from '@/apis/http';
import { apiPath } from '@/config';
import { getIpConfig } from '../../utils/IMEI';
import request from '../../utils/axios';
// 获取图形码
export function queryQuestionImg(data, header) {
    return getBolb(apiPath + '/common/getQuestionImgNew', data, header)
}

// 获取验证码
export function postVerifiCode(data, header) {
    return post(apiPath + '/common/imgCheckSendCode', data, header)
}

// 注册接口
export function postRegister(data, header) {
    return post(apiPath + '/uc/registerAccount/register', data, header)
}

// 获取个人信息
export function queryUserInfo() {
    return get(apiPath + '/uc/user/userinfo/identityInfo')
}



export async function postLogin(data, header) {
    const ip = await getIpConfig();
    data = { ...ip, ...data };
    return request({
        url: apiPath + '/uc/appLogin',
        method: 'POST',
        data,
        header
    })
}
// 基础认证
export function postBaseCheck(data, header) {
    return post(apiPath + '/uc/user/userinfo/baseCheck', data, header)
}